import React from "react";
import YoutubePopup from "../../../core/YoutubePopup/YoutubePopup";
import { ListPanelEntityModel, VideoModel } from "../ListPanelModel";
import { ButtonModel } from "../../../core/Models/ButtonModel";
import ListPanelUtils from "../ListPanelUtils";
import Hyperlink from "../../../core/Hyperlink/Hyperlink";
import Button from "../../../core/Button/Button";
import { useNavigate } from "react-router-dom";
import StoryblokImage from "../../../core/StoryblokImage/StoryblokImage";

const ListPanelItem: React.FC<{
  entity: ListPanelEntityModel;
  containerColor?: string;
  fontFamily?: string;
  showPopup?: string | undefined;
  handleClick?: () => void;
  onVideoButtonClick?: () => void;
}> = ({
  entity,
  containerColor,
  fontFamily,
  showPopup,
  handleClick,
  onVideoButtonClick,
}) => {
  const navigate = useNavigate();
  const itemDescription = ListPanelUtils.getDescription(entity.content);
  const buttons: Array<ButtonModel> = ListPanelUtils.getButtons(
    entity.content,
    entity.full_slug,
  );
  const itemTitle = ListPanelUtils.getTitle(entity.content);
  const isClickable = buttons?.length === 1 && buttons[0].link?.cached_url;
  const itemName = (entity.content as any)?.component;

  const handleImageClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (handleClick) {
      handleClick();
    }
  };

  const onButtonClick = () => {
    if (onVideoButtonClick) {
      onVideoButtonClick();
    }
  };

  const handleItemClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (isClickable) {
      if (buttons[0].link?.linktype === "story") {
        navigate(`/${buttons[0].link?.cached_url}`);
      } else {
        const url = new URL(
          buttons[0].link?.cached_url,
          window.location.origin,
        );
        window.location.href = url.href;
      }
    }
  };

  return (
    <div
      style={{ backgroundColor: containerColor }}
      className={`list-panel-item ${isClickable ? "clickable" : ""} ${itemName} 
      ${itemTitle ? "" : "no-title"}`}
      key={`list-panel-item-${entity.uuid}`}
      onClick={handleItemClick}
    >
      <div>
        <StoryblokImage
          src={ListPanelUtils.getImage(entity.content)?.filename}
          className={
            ListPanelUtils.isVideoEntity(entity.content) ? "img-clickable" : ""
          }
          alt=""
          onClick={handleImageClick}
          sizes="(max-width: 480px) 100vw, (max-width: 768px) 50vw, 33vw"
        />
        {itemTitle && <div className="item-title">{itemTitle}</div>}
        <div className="item-description" style={{ fontFamily: fontFamily }}>
          {itemDescription}
        </div>
      </div>
      {ListPanelUtils.isPageEntity(entity.content) && (
        <div className="action-buttons article-buttons">
          {buttons?.map((button) => (
            <Hyperlink
              blok={button}
              key={`action-button${entity.uuid}${button._uid}${button.link?.cached_url}`}
            ></Hyperlink>
          ))}
        </div>
      )}
      {(ListPanelUtils.isProductEntity(entity.content) ||
        ListPanelUtils.isSolutionsEntity(entity.content)) && (
        <div className="action-buttons">
          {buttons?.map((button) => (
            <Button
              blok={button}
              key={`action-button${entity.uuid}${button._uid}${button.link?.cached_url}`}
            ></Button>
          ))}
        </div>
      )}

      {ListPanelUtils.isVideoEntity(entity.content) &&
        showPopup === entity.uuid && (
          <YoutubePopup
            videoId={(entity.content as VideoModel).youtubeVideoId}
            onButtonClick={onButtonClick}
            key={`YoutubePopup-${entity.uuid}`}
          ></YoutubePopup>
        )}
    </div>
  );
};

export default ListPanelItem;
